module.exports = __webpack_public_path__ + "img/duihuanma.2b2199b8.png";